// Recovered compiled webpack factory 12845. Edit this function expression; run npm run build.
(e, t) => {
  "use strict";
  (Object.defineProperty(t, "__esModule", { value: !0 }),
    !(function (e, t) {
      for (var r in t) Object.defineProperty(e, r, { enumerable: !0, get: t[r] });
    })(t, {
      UnrecognizedActionError: function () {
        return r;
      },
      unstable_isUnrecognizedActionError: function () {
        return n;
      },
    }));
  class r extends Error {
    constructor(...e) {
      (super(...e), (this.name = "UnrecognizedActionError"));
    }
  }
  function n(e) {
    return !!(e && "object" == typeof e && e instanceof r);
  }
  ("function" == typeof t.default || ("object" == typeof t.default && null !== t.default)) &&
    void 0 === t.default.__esModule &&
    (Object.defineProperty(t.default, "__esModule", { value: !0 }),
    Object.assign(t.default, t),
    (e.exports = t.default));
}
